/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import i18n from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { safelyInitI18nForTestsAndStories } from '@opengeoweb/shared';
import sentryTranslations from '../../../locales/sentry.json';

export const SENTRY_NAMESPACE = 'sentry';

export const initSentryI18n = (): void => {
  safelyInitI18nForTestsAndStories(i18n, SENTRY_NAMESPACE, [
    { ns: SENTRY_NAMESPACE, translations: sentryTranslations },
  ]);
};

export const useSentryTranslation = (): UseTranslationResponse<
  typeof SENTRY_NAMESPACE,
  typeof i18n
> => useTranslation(SENTRY_NAMESPACE);

export { i18n, sentryTranslations };
